import { useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';

import { useAllUsers } from '../../app-users/hooks/use-all-users.query';
import {
  settingsInvitedUsersSearchPhraseState,
  settingsInvitedUsersSortState,
} from '../settings.state';
import type { AllUsersQueryParams } from '@/api/v4/user.api';
import { useAtomValue } from 'jotai';

export const useInvitedUsers = () => {
  const sortState = useAtomValue(settingsInvitedUsersSortState);
  const sort = sortState?.sort;
  const direction = sortState?.direction;
  const search = useAtomValue(settingsInvitedUsersSearchPhraseState);

  const queryClient = useQueryClient();

  const params: AllUsersQueryParams = {
    sort,
    direction,
    ...(search && {
      search,
    }),
    statuses: ['invited'],
  };

  const { data, isLoading } = useAllUsers(params);

  const refreshUsers = async () => {
    await queryClient.invalidateQueries({ queryKey: [QueryKey.UsersCount] });
    await queryClient.invalidateQueries({
      queryKey: [QueryKey.UsersAll, params],
    });
  };

  return {
    invitedUsers: data ?? [],
    isLoading,
    refreshUsers,
  };
};
